import { ApiError } from "./client";

// Mappa un errore (di checkout/pagamento) a una chiave i18n localizzata, così al
// cliente non appare mai una stringa tecnica del backend.
export function paymentErrorKey(err: unknown): string {
  if (err instanceof ApiError) {
    switch (err.status) {
      case 503:
        return "checkout.errors.notConfigured";
      case 409:
        return "checkout.errors.alreadyPaid";
      case 404:
        return "checkout.errors.notFound";
      case 502:
        return "checkout.errors.provider";
      case 400:
        return "checkout.errors.cart";
      default:
        return "checkout.errors.generic";
    }
  }
  // fetch fallisce con TypeError su errore di rete (prima di ApiError).
  return "checkout.errors.network";
}
